/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfrastrucureExposureResponseViewModel
 */
export interface InfrastrucureExposureResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof InfrastrucureExposureResponseViewModel
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof InfrastrucureExposureResponseViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastrucureExposureResponseViewModel
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof InfrastrucureExposureResponseViewModel
     */
    id?: string;
}

/**
 * Check if a given object implements the InfrastrucureExposureResponseViewModel interface.
 */
export function instanceOfInfrastrucureExposureResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;

    return isInstance;
}

export function InfrastrucureExposureResponseViewModelFromJSON(json: any): InfrastrucureExposureResponseViewModel {
    return InfrastrucureExposureResponseViewModelFromJSONTyped(json, false);
}

export function InfrastrucureExposureResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfrastrucureExposureResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundName': json['FundName'],
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'total': !exists(json, 'Total') ? undefined : json['Total'],
        'id': !exists(json, 'Id') ? undefined : json['Id'],
    };
}

export function InfrastrucureExposureResponseViewModelToJSON(value?: InfrastrucureExposureResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundName': value.fundName,
        'Percentage': value.percentage,
        'Total': value.total,
        'Id': value.id,
    };
}

